import { alpha } from '@mui/material/styles';
import { gray } from '../ThemePrimitives';

export const surfacesCustomizations = {
  MuiAccordion: {
    defaultProps: {
      elevation: 0,
      disableGutters: true,
    },
    styleOverrides: {
      root: ({ theme }) => ({
        padding: 4,
        overflow: 'clip',
        backgroundColor: alpha(theme.palette.primary.light, 0.03),
        border: '1px solid',
        borderColor: alpha(theme.palette.primary.main, 0.08),
        borderRadius: theme.shape.borderRadius,
        marginBottom: 8,
        transition: 'all 0.3s ease',
        ':before': {
          backgroundColor: 'transparent',
        },
        '&:not(:last-of-type)': {
          borderBottom: 'none',
        },
        ...theme.applyStyles('dark', {
          backgroundColor: alpha(gray[800], 0.3),
          borderColor: alpha(gray[700], 0.5),
        }),
      }),
    },
  },
  MuiAccordionSummary: {
    styleOverrides: {
      root: ({ theme }) => ({
        border: 'none',
        borderRadius: theme.shape.borderRadius,
        padding: '8px 12px',
        transition: 'all 0.2s ease',
        '&:hover': {
          backgroundColor: alpha(theme.palette.primary.main, 0.04),
        },
        '&:focus-visible': {
          backgroundColor: 'transparent',
          outline: `2px solid ${alpha(theme.palette.primary.main, 0.3)}`,
        },
      }),
    },
  },
  MuiAccordionDetails: {
    styleOverrides: {
      root: {
        mb: 16,
        border: 'none',
        padding: '8px 12px',
      },
    },
  },
  MuiPaper: {
    defaultProps: {
      elevation: 0,
    },
    styleOverrides: {
      root: ({ theme }) => ({
        transition: 'all 0.3s ease',
        borderRadius: theme.shape.borderRadius,
        variants: [
          {
            props: { variant: 'outlined' },
            style: {
              border: `1px solid ${alpha(theme.palette.divider, 0.6)}`,
              background: theme.palette.background.paper,
              ...theme.applyStyles('dark', {
                background: alpha(gray[900], 0.9),
              }),
            },
          },
          {
            props: { elevation: 1 },
            style: {
              boxShadow: `0 1px 2px ${alpha(theme.palette.common.black, 0.04)}`,
              ...theme.applyStyles('dark', {
                boxShadow: `0 1px 2px ${alpha(theme.palette.common.black, 0.2)}`,
              }),
            },
          },
          {
            props: { elevation: 2 },
            style: {
              boxShadow: `0 2px 8px ${alpha(theme.palette.common.black, 0.06)}`,
              ...theme.applyStyles('dark', {
                boxShadow: `0 2px 8px ${alpha(theme.palette.common.black, 0.3)}`,
              }),
            },
          },
        ],
      }),
    },
  },
  MuiCard: {
    styleOverrides: {
      root: ({ theme }) => ({
        padding: 0,
        marginBottom: 8,
        transition: 'all 200ms ease',
        backgroundColor: theme.palette.background.paper,
        borderRadius: theme.shape.borderRadius,
        border: `1px solid ${alpha(theme.palette.divider, 0.5)}`,
        ...theme.applyStyles('dark', {
          backgroundColor: gray[800],
        }),
        '&:hover': {
          boxShadow: `0 2px 8px ${alpha(theme.palette.common.black, 0.06)}`,
        },
        variants: [
          {
            props: { variant: 'outlined' },
            style: {
              border: `1px solid ${alpha(theme.palette.divider, 0.5)}`,
              boxShadow: 'none',
              background: theme.palette.background.paper,
              ...theme.applyStyles('dark', {
                background: alpha(gray[900], 0.4),
              }),
            },
          },
        ],
      }),
    },
  },
  MuiCardContent: {
    styleOverrides: {
      root: {
        padding: '20px',
        '&:last-child': {
          paddingBottom: '20px',
        },
      },
    },
  },
  MuiCardHeader: {
    styleOverrides: {
      root: {
        padding: '20px 20px 0',
      },
    },
  },
  MuiCardActions: {
    styleOverrides: {
      root: {
        padding: '12px 20px 20px',
      },
    },
  },
  MuiAppBar: {
    styleOverrides: {
      root: ({ theme }) => ({
        boxShadow: 'none',
        borderBottom: `1px solid ${alpha(theme.palette.divider, 0.15)}`,
        backgroundColor: alpha(theme.palette.background.paper, 0.9),
        backdropFilter: 'blur(8px)',
        backgroundImage: 'none',
        ...theme.applyStyles('dark', {
          backgroundColor: alpha(gray[900], 0.9),
        }),
      }),
    },
  },
};
